module.exports = __webpack_public_path__ + "img/b9bd639.jpg";